import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../api/axiosInstance';
import { useAuth } from '../context/AuthContext';
import { useMemo } from 'react';

/**
 * Fetch the modules for the current role / hotel.
 *  – no initialData  ► React‑Query performs the request once
 *  – staleTime ∞     ► future navigations read from cache
 */
const useDynamicModules = () => {
  const { authData } = useAuth();

  const enabled = useMemo(
    () => !!authData?.token && !!authData?.roleId && !!authData?.hotelId,
    [authData],
  );

  return useQuery({
    queryKey: ['modules', authData?.roleId, authData?.hotelId],
    enabled,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const roleSegment = authData.role
        ? `/${authData.role.toLowerCase()}`
        : '';
      const url = `/modules/my-routes/${authData.roleId}/${authData.hotelId}${roleSegment}`;

      //console.log('[modules] GET', url);
      const { data } = await axiosInstance.get(url);
      //console.log('[modules] raw response:', data);

      return Array.isArray(data) ? data : [];
    },
  });
};

export default useDynamicModules;
